// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__rN2CB","footer":"ChangeClinic_footer__x9hRw"};